import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-07.jpg";
import aiImg from "../../assets/img/ai-WISdoc.png";
import aiIcon01 from "../../assets/img/icon-ai18.png";
import aiIcon02 from "../../assets/img/icon-ai17.png";
import aiIcon03 from "../../assets/img/icon-ai19.png";
import aiIcon04 from "../../assets/img/icon-ai01.png";
import fwImg from "../../assets/img/fw-wisdoc.png";

function WISdoc() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

  //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISdoc 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">AI 문서 처리 솔루션</span>
						<h2>WISdoc</h2>
						<p>WISdoc은 AI 기반 문서 인식과 이해 기술로, 기업의 모든 문서 업무를 혁신하며 비즈니스 프로세스에 활용할 수 있도록 도와줍니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISdoc 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISdoc" /></div>
            <div className="info">
              <p>WISdoc은 AI 기반의 문서 자동화 처리 플랫폼으로, AI 기술을 활용하여 문서 처리 과정을 자동화하는 솔루션입니다. AI 문서 처리기는 문서에서 Context를 추출하고, 내용을 이해하고, 분류하고, 검증하여 비즈니스 프로세스에 활용할 수 있도록 실질적인 업무 자동화와 정보 검색 효율을 극대화합니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">데이터 추출 및 자동화</p>
                  <p className="txt">이미지, 그림, 표를 분리하여 추출, 문서의 맥락·구조·키필드(이름, 금액, 날짜 등)를 자동 분류/요약</p>
                </li>
                 <li>
                  <p className="tit">문서 분류 및 정보 구조화</p>
                  <p className="txt">계약서, 영수증, 세금계산서, 신분증, 의료기록 등 다양한 포맷 인식 구조화된 문서뿐 아니라 비정형 문서도 처리 가능</p>
                </li>
                 <li>
                  <p className="tit">고속 처리 및 효율성</p>
                  <p className="txt">빠른 처리 속도를 지원하며, 자체 보유 솔루션으로 고객 요구에 맞춰 커스터마이징이 가능</p>
                </li>
                 <li>
                  <p className="tit">정확한 정보 추출 및 보안 지원</p>
                  <p className="txt">오타ㆍ식별 오류 자동 감지·교정, 문맥 기반 정보 보강 문서 및 데이터 사용 이력 기록, 접근 권한 및 감사 로그 관리</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="다양한 문서 포맷 지원"/></span>
              <p className="tit">다양한 문서<br/>포맷 지원</p>
              <p className="txt">주로 이용되는 hwp, doc, ppt, pdf, 이미지, html 등의 문서에 대한 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="텍스트, 표, 이미지 등에 대한 구조화된 추출 지원"/></span>
              <p className="tit">텍스트, 표, 이미지 등에<br/>대한 구조화된 추출 지원</p>
              <p className="txt">문서내의 텍스트 뿐만 아니라 표, 이미지 등을 포함하여 추출</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="문서 서식에 대한 데이터 추출 매핑"/></span>
              <p className="tit">문서 서식에 대한<br/>데이터 추출 매핑</p>
              <p className="txt">머신리더블(machine readable)형태로 문서의 주요 서식을 포함 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="당사의 솔루션들과 결합하여 높은 활용성"/></span>
              <p className="tit">당사의 솔루션들과<br/> 결합하여 높은 활용성</p>
              <p className="txt">문서기반의 자동화, 챗봇, 검색 등 다양한 활용 및 확장성 제공</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">문서 오픈</p>
                <p className="txt">문서 포맷 파일</p>
              </li>
              <li>
                <p className="tit">파싱</p>
                <p className="txt">포맷별 문서 파싱 및 공통 데이터 모델</p>
              </li>
              <li>
                <p className="tit">데이터 추출</p>
                <p className="txt">텍스트, 그림, 표 등 데이터 추출</p>
              </li>
              <li>
                <p className="tit">문서 변환</p>
                <p className="txt">전산처리를 위한 형태로 문서 변환</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework" onClick={imgClick} >
              <img src={fwImg} alt="WISdoc 프레임워크" />
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>AI Machine Readable 데이터의 중요성</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">데이터 처리 효율성</p>
                <p className="txt">대규모 데이터를 처리해야하는 경우 Machine Readable의 효율성은 더욱 중요</p>
              </li>
                <li>
                <p className="tit">데이터의 구조화 </p>
                <p className="txt">데이터를 구조화하여 표현 하므로 생성형 AI가 데이터간의 관계를 파악하고 논리적인 추론을 수행, 성능향상에 기여 </p>
              </li>
                <li>
                <p className="tit">데이터 상호 운용성 </p>
                <p className="txt">다양한 시스템간과 애플리케이션 간의 데이터 교환 및 공유에 용이</p>
              </li>
                <li>
                <p className="tit">인공지능 전환(AX)의 핵심기반 기술</p>
                <p className="txt">AX의 핵심 요소는 데이터입니다. 데이터는 AI의 학습과 추론의 기초이며, 이는 인공지능 시스템이 더욱 정확하고 신뢰할 수 있는 결과를 제공할 수 있게 합니다</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISdoc;